/*
 * Virtual try-on tracking + "free fit check" slide-in.
 *
 * Auglio has no public open/close events, so we watch its widget:
 * it is open while #auglio-wrapper is displayed.
 *
 * On open:  "Tried On Product" -> Klaviyo, GA4 (virtual_try_on), Meta (VirtualTryOn).
 * On close: if the try-on stayed open long enough, offer a free optician fit check.
 * On submit: Klaviyo identify + "Requested Fit Check", optional list subscribe,
 *            Formspree email to the team (with optional photo), GA4 generate_lead, Meta Lead.
 */
(function () {
  'use strict';

  var cfg = window.MEG_TRYON || {};
  // 0 = show the fit-check popup after every try-on, however short.
  var MIN_OPEN_MS = (typeof cfg.minOpenSeconds === 'number' ? cfg.minOpenSeconds : 0) * 1000;
  var KEY_DONE = 'meg_fitcheck_done';

  var lastClick = null; // { ctx, at }
  var session = null; // { ctx, openedAt }
  var lastTried = null; // ctx of the most recent try-on, used by the slide-in
  var pollTimer = null;

  /* ---------- storage helpers (never throw) ---------- */
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  /* ---------- product context ---------- */
  function absUrl(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.charAt(0) === '/') return window.location.origin + u;
    return u;
  }

  function parseVariants(str) {
    // "id|price|title;id|price|title"
    if (!str) return [];
    return str.split(';').map(function (row) {
      var p = row.split('|');
      return { id: p[0], price: parseFloat(p[1]) || 0, title: p[2] || '' };
    });
  }

  function ctxFromCardButton(btn) {
    var variants = parseVariants(btn.getAttribute('data-meg-variants'));
    var vid = btn.dataset.item_id;
    var v = variants.filter(function (x) { return x.id === String(vid); })[0] || variants[0] || {};
    return {
      productId: btn.getAttribute('data-meg-product-id') || '',
      variantId: String(vid || v.id || ''),
      title: btn.getAttribute('data-meg-title') || '',
      variantTitle: v.title || '',
      brand: btn.getAttribute('data-meg-brand') || '',
      price: v.price || 0,
      url: absUrl(btn.getAttribute('data-meg-url') || ''),
      image: absUrl(btn.getAttribute('data-meg-image') || ''),
      source: 'collection card'
    };
  }

  function ctxFromProductPage(variantId) {
    var p = cfg.product;
    if (!p) return null;
    var vid = String(variantId || '');
    var v = (p.variants || []).filter(function (x) { return String(x.id) === vid; })[0];
    if (!v) {
      var input = document.querySelector('.installment input[name=id], form[action*="/cart/add"] input[name=id]');
      var cur = input && input.value;
      v = (p.variants || []).filter(function (x) { return String(x.id) === String(cur); })[0] || (p.variants || [])[0] || {};
    }
    return {
      productId: String(p.id),
      variantId: String(v.id || ''),
      title: p.title,
      variantTitle: v.title || '',
      brand: p.vendor || '',
      price: v.price || 0,
      url: absUrl(p.url),
      image: absUrl(v.image || p.image || ''),
      source: 'product page'
    };
  }

  function ctxFromButton(btn) {
    if (btn && btn.hasAttribute('data-meg-variants')) return ctxFromCardButton(btn);
    var fromPage = ctxFromProductPage(btn && btn.dataset ? btn.dataset.item_id : null);
    if (fromPage) return fromPage;
    return genericCtx();
  }

  function genericCtx() {
    return {
      productId: '', variantId: '', title: '', variantTitle: '', brand: cfg.collectionBrand || '',
      price: 0, url: window.location.href.split('#')[0], image: '', source: 'floating icon'
    };
  }

  /* ---------- analytics ---------- */
  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  }

  // "Brand Title", without repeating the brand when the title already starts with it.
  function displayName(ctx) {
    if (!ctx.title) return '';
    var brand = (ctx.brand || '').trim();
    if (!brand || ctx.title.toLowerCase().indexOf(brand.toLowerCase()) === 0) return ctx.title;
    return brand + ' ' + ctx.title;
  }

  function klaviyoProps(ctx) {
    return {
      ProductName: ctx.title,
      DisplayName: displayName(ctx),
      ProductID: ctx.productId,
      VariantID: ctx.variantId,
      VariantName: ctx.variantTitle,
      Brand: ctx.brand,
      Price: ctx.price,
      ProductURL: ctx.url,
      ImageURL: ctx.image,
      PageURL: window.location.href.split('#')[0],
      TryOnSource: ctx.source
    };
  }

  function klaviyoTrack(name, props) {
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track(name, props);
      } else {
        window._learnq = window._learnq || [];
        window._learnq.push(['track', name, props]);
      }
    } catch (e) {}
  }

  function gaItem(ctx) {
    return {
      item_id: ctx.variantId || ctx.productId,
      item_name: ctx.title,
      item_brand: ctx.brand,
      item_variant: ctx.variantTitle,
      price: ctx.price
    };
  }

  function trackOpen(ctx) {
    klaviyoTrack('Tried On Product', klaviyoProps(ctx));
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'virtual_try_on', {
          currency: currency(),
          value: ctx.price || 0,
          try_on_source: ctx.source,
          items: ctx.title ? [gaItem(ctx)] : []
        });
      }
    } catch (e) {}
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      var marketingOk = !(privacy && typeof privacy.marketingAllowed === 'function' && !privacy.marketingAllowed());
      if (marketingOk && typeof window.fbq === 'function') {
        window.fbq('trackSingleCustom', '950476870575755', 'VirtualTryOn', {
          content_ids: ctx.productId ? [ctx.productId] : [],
          content_name: ctx.title,
          content_type: 'product',
          content_category: ctx.brand,
          value: ctx.price || 0,
          currency: currency()
        });
      }
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('virtual_try_on', klaviyoProps(ctx));
      }
    } catch (e) {}
  }

  function trackClose(ctx, ms) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'virtual_try_on_close', {
          try_on_seconds: Math.round(ms / 1000),
          item_name: ctx.title || '(none)'
        });
      }
    } catch (e) {}
  }

  function trackLead(ctx) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', {
          currency: currency(),
          value: ctx.price || 0,
          lead_source: 'virtual try-on fit check',
          items: ctx.title ? [gaItem(ctx)] : []
        });
      }
    } catch (e) {}
    // Meta Lead goes through the site-wide helper so it stays one Lead per session
    // (shared with the Rx chat / Rx quiz) and respects marketing consent.
    try {
      if (typeof window.megRxLead === 'function') window.megRxLead('Virtual try-on fit check');
    } catch (e) {}
  }

  /* ---------- open / close detection ---------- */
  function widgetOpen() {
    var w = document.getElementById('auglio-wrapper');
    if (!w) return false;
    return window.getComputedStyle(w).display !== 'none';
  }

  function onOpened() {
    if (session) return;
    var ctx = lastClick && Date.now() - lastClick.at < 15000 ? lastClick.ctx : (cfg.product ? ctxFromProductPage() : genericCtx());
    session = { ctx: ctx, openedAt: Date.now() };
    lastTried = ctx;
    trackOpen(ctx);
    startPolling();
  }

  function onClosed() {
    if (!session) return;
    var ms = Date.now() - session.openedAt;
    var ctx = session.ctx;
    session = null;
    stopPolling();
    trackClose(ctx, ms);
    if (ms >= MIN_OPEN_MS) {
      window.setTimeout(function () { maybeShowSlideIn(ctx); }, 700);
    }
  }

  function startPolling() {
    stopPolling();
    pollTimer = window.setInterval(function () {
      if (!widgetOpen()) onClosed();
    }, 700);
  }

  function stopPolling() {
    if (pollTimer) window.clearInterval(pollTimer);
    pollTimer = null;
  }

  function watchForOpen() {
    // Opening adds a class to <body>; catch every entry point (cards, product page, floating icon).
    var obs = new MutationObserver(function () {
      if (!session && widgetOpen()) onOpened();
    });
    obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('click', function (e) {
      var path = e.composedPath ? e.composedPath() : [e.target];
      var el = path[0] && path[0].closest ? path[0] : e.target;
      var btn = el && el.closest ? el.closest('.auglio-tryon-btn') : null;
      var bubble = !btn && el && el.closest ? el.closest('.auglio-floating-icon') : null;
      if (!btn && !bubble) return;
      lastClick = { ctx: btn ? ctxFromButton(btn) : genericCtx(), at: Date.now() };
      // Fallback in case the body class never changes (widget versions differ).
      var tries = 0;
      var t = window.setInterval(function () {
        tries++;
        if (session || tries > 20) return window.clearInterval(t);
        if (widgetOpen()) { window.clearInterval(t); onOpened(); }
      }, 500);
    }, true);
  }

  /* ---------- try-on buttons on collection cards ---------- */
  var checkedVariants = {}; // variantId -> Auglio data, or false

  function cardButtons(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll('.meg-card-tryon[data-meg-variants]'));
  }

  function checkVariantIds(ids) {
    var todo = ids.filter(function (id) { return !(id in checkedVariants); });
    if (!todo.length) return Promise.resolve();
    return fetch('https://tryon.auglio.com/api/check-item-ids', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ item_ids: todo, partner_id: cfg.auglioPartnerId || 9478, ignore_published: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (rows) {
        todo.forEach(function (id) { checkedVariants[id] = false; });
        (rows || []).forEach(function (row) { checkedVariants[String(row.item_id)] = row; });
      })
      .catch(function () {});
  }

  function applyVariant(btn, id) {
    var row = checkedVariants[String(id)];
    if (!row) return false;
    btn.dataset.item_id = String(id);
    btn.dataset.product_id = row.product_id;
    btn.dataset.category_id = row.category_id;
    btn.dataset.group_id = row.group_id;
    btn.dataset.full_3d = row.full_3d;
    btn.style.display = '';
    btn.classList.add('is-ready');
    return true;
  }

  function setupCards(root) {
    var btns = cardButtons(root).filter(function (b) { return !b.dataset.megInit; });
    if (!btns.length) return;
    var ids = [];
    btns.forEach(function (b) {
      b.dataset.megInit = '1';
      parseVariants(b.getAttribute('data-meg-variants')).forEach(function (v) { ids.push(v.id); });
    });
    // Auglio accepts batches; keep requests reasonable.
    var chunks = [];
    for (var i = 0; i < ids.length; i += 200) chunks.push(ids.slice(i, i + 200));
    Promise.all(chunks.map(checkVariantIds)).then(function () {
      btns.forEach(function (b) {
        var variants = parseVariants(b.getAttribute('data-meg-variants'));
        var preferred = b.dataset.item_id;
        if (applyVariant(b, preferred)) return;
        for (var j = 0; j < variants.length; j++) {
          if (applyVariant(b, variants[j].id)) return;
        }
        var wrap = b.closest('.meg-card-tryon-wrap');
        if (wrap) wrap.classList.add('is-unavailable'); // keep the space so card rows stay aligned
      });
    });
  }

  function onSwatchChange(e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    var card = input.closest('.card-wrapper, .product-card-wrapper, .card, li');
    var btn = card && card.querySelector('.meg-card-tryon[data-meg-variants]');
    if (!btn) return;
    var value = String(input.value || '').trim();
    var match = parseVariants(btn.getAttribute('data-meg-variants')).filter(function (v) {
      return v.title.split(' / ').map(function (s) { return s.trim(); }).indexOf(value) !== -1 && checkedVariants[v.id];
    })[0];
    if (match) applyVariant(btn, match.id);
  }

  function watchGrid() {
    var grid = document.getElementById('ProductGridContainer') || document.querySelector('.collection, main');
    if (!grid) return;
    var timer = null;
    new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { setupCards(document); }, 250);
    }).observe(grid, { childList: true, subtree: true });
  }

  /* ---------- slide-in ---------- */
  var panel, form, statusEl, submitBtn;

  // Shows after every try-on, on any page. Closing it doesn't hide it next time;
  // only a submitted request stops it (no need to ask again).
  function suppressed() {
    return !!lsGet(KEY_DONE);
  }

  function forceShow() {
    return /[?&]fitcheck=1\b/.test(window.location.search);
  }

  function fillProduct(ctx) {
    var box = panel.querySelector('[data-fc-product]');
    var img = panel.querySelector('[data-fc-image]');
    var name = panel.querySelector('[data-fc-name]');
    var heading = panel.querySelector('[data-fc-heading]');
    if (ctx && ctx.title) {
      box.hidden = false;
      name.textContent = displayName(ctx) + (ctx.variantTitle && ctx.variantTitle !== 'Default Title' ? ' · ' + ctx.variantTitle : '');
      if (ctx.image) { img.src = ctx.image; img.alt = ctx.title; img.hidden = false; } else { img.hidden = true; }
      heading.textContent = heading.getAttribute('data-with-product');
    } else {
      box.hidden = true;
      heading.textContent = heading.getAttribute('data-without-product');
    }
  }

  function maybeShowSlideIn(ctx) {
    if (!panel) return;
    if (!forceShow() && suppressed()) return;
    lastTried = ctx || lastTried;
    fillProduct(lastTried);
    panel.hidden = false;
    document.documentElement.classList.add('meg-fc-open');
    // next frame so the transition runs
    window.requestAnimationFrame(function () { panel.classList.add('is-open'); });
    var first = panel.querySelector('input[name="first_name"]');
    if (first && window.matchMedia('(pointer: fine)').matches) first.focus({ preventScroll: true });
    try { if (typeof window.gtag === 'function') window.gtag('event', 'fit_check_offer_shown', { item_name: (lastTried && lastTried.title) || '(none)' }); } catch (e) {}
  }

  function closeSlideIn(remember) {
    if (!panel) return;
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('meg-fc-open');
    window.setTimeout(function () { panel.hidden = true; }, 300);
  }

  function value(name) {
    var el = form.querySelector('[name="' + name + '"]');
    if (!el) return '';
    if (el.type === 'radio') {
      var c = form.querySelector('[name="' + name + '"]:checked');
      return c ? c.value : '';
    }
    return (el.value || '').trim();
  }

  function setStatus(msg, isError) {
    statusEl.textContent = msg || '';
    statusEl.classList.toggle('is-error', !!isError);
  }

  function sendFormspree(ctx, includeFile) {
    if (!cfg.formEndpoint) return Promise.resolve();
    var body = new FormData();
    var name = value('first_name') || 'New lead';
    body.append('_subject', 'Fit check request: ' + name + (ctx.title ? ' – ' + ctx.title : ''));
    body.append('_replyto', value('email'));
    body.append('email', value('email'));
    body.append('First name', value('first_name'));
    if (value('phone')) body.append('Phone', value('phone'));
    body.append('Needs prescription lenses', value('rx') || 'Not answered');
    body.append('Frame tried on', ctx.title ? (ctx.title + (ctx.variantTitle && ctx.variantTitle !== 'Default Title' ? ' (' + ctx.variantTitle + ')' : '')) : 'Not captured');
    if (ctx.url) body.append('Frame link', ctx.url);
    if (ctx.price) body.append('Price', '$' + ctx.price);
    body.append('Page', window.location.href.split('#')[0]);
    if (value('notes')) body.append('Notes', value('notes'));
    body.append('Marketing opt-in', form.querySelector('[name="opt_in"]').checked ? 'Yes' : 'No');
    body.append('Lead source', 'Virtual try-on fit check');
    var hp = form.querySelector('[name="_gotcha"]');
    if (hp && hp.value) body.append('_gotcha', hp.value);
    var fileInput = form.querySelector('[name="photo"]');
    var file = fileInput && fileInput.files && fileInput.files[0];
    if (file && includeFile) body.append('upload', file, file.name);
    if (file && !includeFile) body.append('Photo', 'Upload failed – ask the customer to reply with a photo.');
    return fetch(cfg.formEndpoint, { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) {
        if (!r.ok) {
          var err = new Error('Formspree ' + r.status);
          err.hadFile = !!(file && includeFile);
          throw err;
        }
      });
  }

  function sendKlaviyo(ctx) {
    var email = value('email');
    var optIn = form.querySelector('[name="opt_in"]').checked;
    var profile = {
      $email: email,
      $first_name: value('first_name') || undefined,
      'Fit check requested': true,
      'Fit check frame': ctx.title || undefined,
      'Needs prescription lenses': value('rx') || undefined
    };
    if (value('phone')) profile['Fit check phone'] = value('phone');
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify(profile); } catch (e) {}
    var props = klaviyoProps(ctx);
    props.NeedsPrescription = value('rx') || '';
    props.Notes = value('notes') || '';
    props.HasPhoto = !!(form.querySelector('[name="photo"]').files || [])[0];
    props.MarketingOptIn = optIn;
    // Sent through the Client API (not the onsite script) so the flow trigger
    // never depends on the visitor's cookie/consent state.
    var profileProps = { 'Fit check requested': true, 'Needs prescription lenses': value('rx') || '' };
    if (ctx.title) profileProps['Fit check frame'] = ctx.title;
    if (value('phone')) profileProps['Fit check phone'] = value('phone');
    var profileAttrs = { email: email, properties: profileProps };
    if (value('first_name')) profileAttrs.first_name = value('first_name');
    return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(cfg.klaviyoCompanyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: props,
            value: ctx.price || 0,
            metric: { data: { type: 'metric', attributes: { name: 'Requested Fit Check' } } },
            profile: { data: { type: 'profile', attributes: profileAttrs } }
          }
        }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('Klaviyo event ' + r.status);
    }).then(function () {
      // Everyone who asks for a fit check joins the list; consent is unchanged.
      if (cfg.listEndpoint) {
        fetch(cfg.listEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, first_name: value('first_name') || '' }),
          keepalive: true
        }).catch(function () {});
      }
      if (!optIn || !cfg.klaviyoCompanyId || !cfg.klaviyoListId) return;
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.klaviyoCompanyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Virtual try-on fit check',
              profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
            },
            relationships: { list: { data: { type: 'list', id: cfg.klaviyoListId } } }
          }
        })
      }).catch(function () {});
    });
  }

  function onSubmit(e) {
    e.preventDefault();
    var email = value('email');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus('Please enter a valid email address.', true);
      form.querySelector('[name="email"]').focus();
      return;
    }
    var fileInput = form.querySelector('[name="photo"]');
    var file = fileInput.files && fileInput.files[0];
    if (file && file.size > 10 * 1024 * 1024) {
      setStatus('That photo is over 10 MB. Please choose a smaller one.', true);
      return;
    }
    var ctx = lastTried || genericCtx();
    submitBtn.disabled = true;
    setStatus('Sending…');
    // Either channel succeeding counts as received: Formspree alerts the team,
    // Klaviyo starts the follow-up emails.
    var klaviyoDone = sendKlaviyo(ctx).then(function () { return true; }, function () { return false; });
    var formDone = sendFormspree(ctx, true)
      .catch(function (err) {
        if (err && err.hadFile) return sendFormspree(ctx, false);
        throw err;
      })
      .then(function () { return true; }, function () { return false; });
    Promise.all([formDone, klaviyoDone])
      .then(function (ok) { if (!ok[0] && !ok[1]) throw new Error('both failed'); })
      .then(function () {
        lsSet(KEY_DONE, String(Date.now()));
        trackLead(ctx);
        var first = value('first_name');
        panel.querySelector('[data-fc-success-name]').textContent = first ? ', ' + first : '';
        panel.classList.add('is-done');
        setStatus('');
      })
      .catch(function () {
        submitBtn.disabled = false;
        setStatus('Something went wrong. Please try again, or text us at ' + (cfg.phoneDisplay || '833-EYE-GEMS') + '.', true);
      });
  }

  function setupSlideIn() {
    panel = document.getElementById('meg-fitcheck');
    if (!panel) return;
    form = panel.querySelector('form');
    statusEl = panel.querySelector('[data-fc-status]');
    submitBtn = panel.querySelector('[type="submit"]');
    form.addEventListener('submit', onSubmit);
    panel.querySelectorAll('[data-fc-dismiss]').forEach(function (b) {
      b.addEventListener('click', function () { closeSlideIn(!panel.classList.contains('is-done')); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) closeSlideIn(!panel.classList.contains('is-done'));
    });
    var fileInput = form.querySelector('[name="photo"]');
    var fileLabel = panel.querySelector('[data-fc-file-label]');
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      fileLabel.textContent = f ? f.name : fileLabel.getAttribute('data-default');
    });
    if (forceShow()) window.setTimeout(function () { maybeShowSlideIn(cfg.product ? ctxFromProductPage() : null); }, 1500);
  }

  /* ---------- open the store chat from any [data-meg-open-chat] ---------- */
  function setupChatLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-meg-open-chat]');
      if (!a) return;
      var chat = document.querySelector('shopify-chat');
      if (!chat) return;
      e.preventDefault();
      // Delay a tick so Inbox doesn't treat this tap as an outside click and close.
      window.setTimeout(function () {
        if (typeof chat.show === 'function') return chat.show();
        var btn = chat.shadowRoot && chat.shadowRoot.querySelector('button.activator');
        if (btn) btn.click();
      }, 50);
    });
  }

  function init() {
    watchForOpen();
    setupSlideIn();
    setupChatLinks();
    if (cardButtons().length) {
      setupCards(document);
      watchGrid();
      document.addEventListener('change', onSwatchChange);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
